export default __webpack_public_path__ + "static/media/left.0d0c4d36.svg";